import { useEffect, useState } from "react";
import { Timer, X } from "lucide-react";

export const LAUNCH_ENDS_AT = new Date("2026-10-27T23:59:59Z").getTime();

export function useLaunchCountdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const ms = Math.max(0, LAUNCH_ENDS_AT - now);
  const s = Math.floor(ms / 1000);
  return { live: ms > 0, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ c, testid }) => (
  <span className="font-mono tabular-nums" data-testid={testid}>
    {c.d}d {pad(c.h)}h {pad(c.m)}m {pad(c.s)}s
  </span>
);

const BANNER_KEY = "kk_reactor_banner_closed";

export const LaunchBanner = () => {
  const [open, setOpen] = useState(() => localStorage.getItem(BANNER_KEY) !== "1");
  if (!open) return null;
  const close = () => { localStorage.setItem(BANNER_KEY, "1"); setOpen(false); };
  return (
    <div className="flex items-center gap-3 border border-[#c48bff]/60 bg-[#c48bff]/10 px-5 py-3 text-sm" data-testid="reactor-banner">
      <a href="#reactor" className="flex flex-wrap items-center gap-x-4 gap-y-1 flex-1 group" data-testid="reactor-banner-link">
        <span className="font-display uppercase tracking-wide text-[#c48bff]">New · KolorKlinic Reactor</span>
        <span className="text-[#f2f4f8]">Film colour looks plus the full Texture engine. €129, or €79 if you own Texture.</span>
        <span className="font-mono text-xs uppercase tracking-widest text-[#9ba3b4] group-hover:text-white transition-colors">try it free →</span>
      </a>
      <button onClick={close} aria-label="Close" className="text-[#9ba3b4] hover:text-white transition-colors p-1" data-testid="reactor-banner-close"><X size={16} /></button>
    </div>
  );
};

export const LaunchBadge = () => {
  const c = useLaunchCountdown();
  if (!c.live) return null;
  return (
    <div className="chip mb-3 text-[#00e5ff] border-[#00e5ff] w-fit" data-testid="launch-hero-badge">
      <span className="status-dot ok" />Denoise + Skin now available
    </div>
  );
};

export const LaunchCardTimer = ({ testid = "launch-card-timer" }) => {
  const c = useLaunchCountdown();
  if (!c.live) return null;
  return (
    <div className="flex items-center gap-2 text-xs text-[#9ba3b4] border border-[#2a2f3d] px-3 py-2" data-testid={testid}>
      <Timer size={13} className="text-[#00e5ff]" /> Launch week ends in <Countdown c={c} testid={`${testid}-countdown`} />
    </div>
  );
};
